/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEaseOut = createReactComponent("outline", "ease-out", "IconEaseOut", [["path", { "d": "M3 20s10 -16 18 -16", "key": "svg-0" }]]);

export { IconEaseOut as default };
//# sourceMappingURL=IconEaseOut.mjs.map
